// extracted by mini-css-extract-plugin
module.exports = {"time":"AdExitTime_time__3hl9f","city":"AdExitTime_city__CAh48"};